import { useCallback, useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

export const CategoriesAdmin = () => {
  const [cats, setCats] = useState([]);
  const [n, setN] = useState({ slug: "", name_en: "", name_it: "", order: 10 });

  const load = useCallback(async () => {
    try { const { data } = await api.get("/admin/categories"); setCats(Array.isArray(data) ? data : []); }
    catch (e) { toast.error(errMsg(e, "Errore")); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const update = async (c) => {
    try { await api.put(`/admin/categories/${c.slug}`, c); toast.success("Categoria aggiornata"); } catch (e) { toast.error(errMsg(e, "Errore")); }
  };
  const add = async () => {
    if (!n.slug || !n.name_en || !n.name_it) { toast.error("Compila tutti i campi"); return; }
    try { await api.post("/admin/categories", { ...n, order: Number(n.order) }); setN({ slug: "", name_en: "", name_it: "", order: 10 }); load(); } catch (e) { toast.error(errMsg(e, "Errore")); }
  };
  const remove = async (c) => {
    if (!window.confirm(`Eliminare la categoria ${c.name_it}?`)) return;
    try { await api.delete(`/admin/categories/${c.slug}`); load(); } catch (e) { toast.error(errMsg(e, "Errore")); }
  };
  const edit = (slug, k, val) => setCats((cs) => cs.map((c) => (c.slug === slug ? { ...c, [k]: val } : c)));

  return (
    <section className="max-w-4xl" data-testid="admin-categories">
      <p className="text-sm text-[#555555] mb-6">Tipologie di pietra usate nei filtri dell’archivio. Modifica i nomi e premi Invio o esci dal campo per salvare.</p>
      <div className="border-t border-[#1A1A1A]/12">
        {cats.map((c) => (
          <div key={c.slug} className="grid grid-cols-12 gap-4 items-end py-4 border-b border-[#1A1A1A]/10" data-testid={`admin-cat-${c.slug}`}>
            <span className="col-span-12 sm:col-span-2 f-mono text-xs pb-3">{c.slug}</span>
            {["name_en", "name_it"].map((k) => (
              <input key={k} className="field col-span-5 sm:col-span-4 text-sm" value={c[k]} onChange={(e) => edit(c.slug, k, e.target.value)} onBlur={() => update(c)} placeholder={k === "name_en" ? "EN" : "IT"} />
            ))}
            <input type="number" className="field col-span-2 sm:col-span-1 text-sm" value={c.order} onChange={(e) => edit(c.slug, "order", Number(e.target.value))} onBlur={() => update(c)} title="Ordine" />
            <button type="button" onClick={() => remove(c)} className="col-span-12 sm:col-span-1 p-2 text-[#8a3b2e] justify-self-end" aria-label="Elimina"><Trash2 className="w-4 h-4" strokeWidth={1.25} /></button>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-12 gap-4 items-end mt-8">
        <input className="field col-span-12 sm:col-span-2 text-sm f-mono" placeholder="slug" value={n.slug} onChange={(e) => setN({ ...n, slug: e.target.value })} data-testid="new-cat-slug" />
        <input className="field col-span-6 sm:col-span-4 text-sm" placeholder="Nome EN" value={n.name_en} onChange={(e) => setN({ ...n, name_en: e.target.value })} data-testid="new-cat-en" />
        <input className="field col-span-6 sm:col-span-4 text-sm" placeholder="Nome IT" value={n.name_it} onChange={(e) => setN({ ...n, name_it: e.target.value })} data-testid="new-cat-it" />
        <button type="button" onClick={add} className="col-span-12 sm:col-span-2 min-h-[44px] bg-[#1A1A1A] text-[#FFFFFF] text-xs tracking-[0.14em] uppercase" data-testid="new-cat-add">Aggiungi</button>
      </div>
    </section>
  );
};
